import * as $ from 'jquery';

export default function registerSearchSortHandler() {
  $('select[name="sort"]').on('change', function () {
    $(this).closest('form').trigger('submit');
  });
}
